// Ported from twifi-theme-html/src/scripts/helpers/product-quantity.js
// Drives the real quantity input in woocommerce/global/quantity-input.php's add-to-cart form.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-hero__quantity').forEach((wrapper) => {
        const input = wrapper.querySelector('.product-hero__quantity-input');
        const decrease = wrapper.querySelector('[data-quantity-decrease]');
        const increase = wrapper.querySelector('[data-quantity-increase]');
        const min = Number(input.min) || 1;
        const max = input.max ? Number(input.max) : Infinity;

        decrease.addEventListener('click', () => {
            input.value = Math.max(min, Number(input.value) - 1);
        });

        increase.addEventListener('click', () => {
            input.value = Math.min(max, Number(input.value) + 1);
        });
    });
});
